import React from 'react';
import { SpaceBetween } from '@amzn/awsui-components-core';
import { Employee } from '../../interfaces/interface';
import { EmployeeListItem } from './EmployeeListItem';
import './EmployeeResultsList.scss';

interface EmployeeResultsListProps {
  employees: Employee[];
  onEmployeeSelect: (employee: Employee) => void;
  isLoading?: boolean;
  noResultsMessage?: string;
  maxHeight?: string;
  searchQuery?: string;
  renderActions?: (employee: Employee) => React.ReactNode;
  showDetails?: boolean;
  getEmployeeDisabled?: (employee: Employee) => boolean;
}

export const EmployeeResultsList: React.FC<EmployeeResultsListProps> = ({
  employees,
  onEmployeeSelect,
  isLoading = false,
  noResultsMessage = 'No results found',
  maxHeight = '150px',
  searchQuery,
  renderActions,
  showDetails = true,
  getEmployeeDisabled
}) => {
  // Show loading state
  if (isLoading) {
    return <span className="loading-message">Searching...</span>;
  }

  // Show no results message - consistent behavior regardless of searchQuery state
  if (employees.length === 0) {
    const message = searchQuery ? `No matches found for "${searchQuery}"` : noResultsMessage;
    return <span className="no-results-message">{message}</span>;
  }

  return (
    <div className="employee-results-list" style={{ maxHeight }}>
      <SpaceBetween direction="vertical" size="xxs">
        {employees.map((employee: Employee, index: number) => {
          const isDisabled = getEmployeeDisabled ? getEmployeeDisabled(employee) : false;
          return (
            <EmployeeListItem
              key={`employee-${employee.login_name}-${index}`}
              employee={employee}
              onClick={() => onEmployeeSelect(employee)}
              showDetails={showDetails}
              disabled={isDisabled}
              renderActions={renderActions ? () => renderActions(employee) : undefined}
            />
          );
        })}
      </SpaceBetween>
    </div>
  );
};
